import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import SubNav from './Common/SubNav';
import Footer from './Common/Footer';
import RadioButtons from './Common/RadioButtons';
import { alertAction } from '../Redux/Actions/alertAction';

const AddExpenses = ({ isShow, setIsShow }) => {
    const [isCheque, setIsCheque] = useState(false);
    const { slug } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const initialValues = { category: '', paidTo: '', amount: '', bill: '', expDate: '', checkNo: '', issueDate: '', remarks: '', bank: '' };
    const [formErrors, setFormErrors] = useState({});
    const [formValues, setFormValues] = useState(initialValues);
    const [isSubmit, setIsSubmit] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setFormErrors(validate(formValues));
        setIsSubmit(true);
        console.log(formValues);
    };

    useEffect(() => {
        if (Object.keys(formErrors).length === 0 && isSubmit) {
            navigate('/admin/expenses/all');
            dispatch(alertAction());
            setIsSubmit(false);
        }

    }, [formErrors, isSubmit])


    const validate = (values) => {
        const errros = {};
        return validation(values, errros, isCheque);
    };

    useEffect(() => {
        if (slug) {
            setFormValues({ category: 'Office exp', paidTo: 'ert', amount: '3000', bill: '44', expDate: '2022-05-12', checkNo: '', issueDate: '', remarks: 'hello', bank: '' })
        }
    }, [slug])


    return (
        <div className='page_first_div'>
            <SubNav isShow={isShow} setIsShow={setIsShow} />
            <div className='page_sec_div '>
                <p className='page_topic inline-block'>{`${slug ? "Edit" : "Add"} Expenses`}</p>
                <div className='inline-block bg-cyan-600 px-3 py-1 ml-2 rounded-md hover:bg-cyan-700 animation'>
                    <Link to="/admin/expenses/all" className='link block text-white text-sm'>
                        <i className="fa-solid fa-arrow-left mr-1"></i>
                        All
                    </Link>
                </div>
                <section className='page_section px-4 xsm:px-8 py-2 min-h-[25rem]'>

                    {/* Add Expenses Details*/}
                    <form action="" onSubmit={handleSubmit}>
                        <div className='grid gap-4 lg:grid-cols-2 lg:gap-6 pt-10'>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider '>Category<span className='text-red-500'>&#42;</span>
                                </p>
                                <input type="text" className='form_input border-2 h-10 w-full placeholder:text-xs xsm:placeholder:text-sm' placeholder='Add Category' name='category' value={formValues.category} onChange={handleChange} />
                                <small className="text-red-500 tracking-wide">{formErrors.category}</small>
                            </div>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider '>Paid To<span className='text-red-500'>&#42;</span>
                                </p>
                                <input type="text" className='form_input border-2 h-10 w-full placeholder:text-xs xsm:placeholder:text-sm' placeholder='Provide Paid to' name='paidTo' value={formValues.paidTo.toUpperCase()} onChange={handleChange} />
                                <small className="text-red-500 tracking-wide">{formErrors.paidTo}</small>
                            </div>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider'>Payment Amount<span className='text-red-500'>&#42;</span></p>
                                <div className='flex justify-center items-baseline h-10 w-full border-2 text-gray-700 outline-gray-300 rounded'>
                                    <p className='h-full text-center flex-1 px-1 sm:px-0'>Rs.</p>
                                    <input type="number" className='placeholder:text-gray-700 flex-[9] outline-none h-full pr-6 border-l-2 pl-2 text-sm placeholder:text-xs xsm:placeholder:text-sm' placeholder='Enter Amount' name='amount' value={formValues.amount} onChange={handleChange} />
                                </div>
                                <small className="text-red-500 tracking-wide">{formErrors.amount}</small>
                            </div>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider'>Reference Bill<span className='text-red-500'>&#42;</span>
                                </p>
                                <input type="text" className='form_input border-2 pr-6 h-10 w-full placeholder:text-xs xsm:placeholder:text-sm' placeholder='Provide bill no' name='bill' value={formValues.bill} onChange={handleChange} />
                                <small className="text-red-500 tracking-wide">{formErrors.bill}</small>
                            </div>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider '>Expense Date<span className='text-red-500'>&#42;</span>
                                </p>
                                <input type="date" className='form_input_date border-2 h-10 w-full placeholder:text-xs xsm:placeholder:text-sm' name='expDate' value={formValues.expDate} onChange={handleChange} />
                                <small className="text-red-500 tracking-wide">{formErrors.expDate}</small>
                            </div>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider '>Response/feedback/Remarks</p>
                                <textarea className='pl-4 pt-2 text-gray-800 text-sm h-16  w-full outline-none border-2 rounded placeholder:text-xs xsm:placeholder:text-sm' placeholder='Remarks...' name='remarks' value={formValues.remarks} onChange={handleChange}></textarea>
                            </div>
                            <div className='font-lato'>
                                <h3 className='text-gray-800 font-semibold tracking-wider text-sm xsm:text-base '>Payment Modes<span className='text-red-500'>&#42;</span></h3>
                                <RadioButtons setIsCheque={setIsCheque} />
                            </div>

                            {/* dynamic rendering for payment mode */}
                            {isCheque && <>
                                <div className='font-lato text-sm xsm:text-base '>
                                    <p className='text-gray-800 font-semibold tracking-wider'>Check No<span className='text-red-500'>&#42;</span>
                                    </p>
                                    <input type="number" className='form_input border-2 pr-6 h-10 w-full placeholder:text-xs xsm:placeholder:text-sm' placeholder='Please Provide Cheque Number' name='checkNo' value={formValues.checkNo} onChange={handleChange} />
                                    <small className="text-red-500 tracking-wide">{formErrors.checkNo}</small>
                                </div>
                                <div className='font-lato text-sm xsm:text-base '>
                                    <p className='text-gray-800 font-semibold tracking-wider '>Bank Name<span className='text-red-500'>&#42;</span>
                                    </p>
                                    <input type="text" className='form_input border-2 h-10 w-full placeholder:text-xs xsm:placeholder:text-sm' placeholder='Please Provide Bank Name' name='bank' value={formValues.bank} onChange={handleChange} />
                                    <small className="text-red-500 tracking-wide">{formErrors.bank}</small>
                                </div>
                                <div className='font-lato text-sm xsm:text-base '>
                                    <p className='text-gray-800 font-semibold tracking-wider '>Issued Date<span className='text-red-500'>&#42;</span>
                                    </p>
                                    <input type="date" className='form_input_date border-2 h-10 w-full placeholder:text-xs xsm:placeholder:text-sm' name='issueDate' value={formValues.issueDate} onChange={handleChange} />
                                    <small className="text-red-500 tracking-wide">{formErrors.issueDate}</small>
                                </div>
                            </>}
                        </div>
                        <div className='pt-4 lg:pt-10'>
                            <button className='button mr-2' type='submit'>{`${slug ? "Update" : "Save"}`}</button>
                            <button className='button2' onClick={() => setFormValues(initialValues)}>Reset</button>
                        </div>
                    </form>
                </section>
            </div>
            <Footer />
        </div>
    )
}

export default AddExpenses;

function validation(values, errros, isCheque) {
    if (!values.category) {
        errros.category = "This field is mandatory!";
    }
    if (!values.paidTo) {
        errros.paidTo = "This field is mandatory!";
    }
    if (!values.amount) {
        errros.amount = "This field is mandatory!";
    }
    if (!values.bill) {
        errros.bill = "This field is mandatory!";
    }
    if (!values.expDate) {
        errros.expDate = "This field is mandatory!";
    }
    if (!values.bank && isCheque) {
        errros.bank = "This field is mandatory!";
    }
    if (!values.checkNo && isCheque) {
        errros.checkNo = "This field is mandatory!";
    }
    if (!values.issueDate && isCheque) {
        errros.issueDate = "This field is mandatory!";
    }
    return errros;
}
